<div #notificationWrapper
  tabindex="-1"
  class='order-notification-wrapper primary-bg-color primary-text-color'
  [ngStyle]="{
    'right': rightPosition,
    'max-width': maxWidth
  }"
  *ngIf="(notificationItem || notificationSpecial || notificationCoupon) && !orderTreeIsOpen">
  <ng-container *ngIf="notificationItem || notificationSpecial">
    <ng-container *ngIf="!(viewportService?.viewport$ | async)?.isMobile">
      <div class='padding-wrapper'>
        <div class='item-notification-wrapper'>
          <div class='quantity' *ngIf="notificationItem">
            <p class='lead no-margin fw-600'>{{notificationItem?.requestedQuantity}}</p>
          </div>
          <div class='text'>
            <fts-order-notification-item-info [item]="notificationItem" [special]="notificationSpecial?.special"></fts-order-notification-item-info>

            <fts-order-notification-info-message [message]="infoMessage"></fts-order-notification-info-message>

            <fts-order-notification-upsell-done-message
              *ngIf="showUpsizeDoneMessage || showUpingredientDoneMessage"
              [message]="(showUpsizeDoneMessage ? 'component.order_notification.size_updated' : 'component.order_notification.ingredient_added') | translate">
            </fts-order-notification-upsell-done-message>
          </div>
        </div>

        <fts-order-notification-upsell-button
          *ngIf="(notificationItem?.sizeUpsell && !showUpsizeDoneMessage) || (!notificationItem?.sizeUpsell && notificationItem?.ingredientUpsell && !showUpingredientDoneMessage && !hideIngrUpsellAfterSizeUp)"
          [btnLabel]="upsellBtnLabel"
          [loadingSubscription]="notificationItem?.sizeUpsell ? upsellSizeSubscription : upsellIngredientSubscription"
          (click)="upsellBtnClick(notificationItem)">
        </fts-order-notification-upsell-button>

        <p *ngIf='notificationItem?.sizeUpsell && !showUpsizeDoneMessage && upsellingSizeCalories' class='text-center margin-top-5 margin-bottom-0 fw-500'>
          {{upsellingSizeCalories}}
        </p>

      </div>

      <hr class='no-margin' aria-hidden="true">

      <div class='padding-wrapper'>
        <div class='buttons-wrapper-notif'>
            <button class='btn btn-block shadowed font-secondary view-order-btn text-uppercase' id='order-notification-view-order-btn' (click)="toggleOrderTree()" [disabled]="this.upsellSizeSubscription && !this.upsellSizeSubscription.closed">
              {{'component.order_notification.view_order' | translate}}
            </button>
            <fts-checkout-button
              [account]='account'
              [order]='order'
              [groupOrder]="groupOrder"
              [buttonId]="'notification-checkout'"
              [reduceBtnSize]='true'
              (checkoutHandled)="dismissNotification()">
            </fts-checkout-button>
          </div>
          <button *ngIf="!(viewportService?.viewport$ | async)?.isDesktop && !(inOrderDetails$ | async)" #continueShoppingBtn class='btn primary-bg-color selection-border-color selection-text-color selection-btn font-secondary checkout-button btn-wrap-text wrap-text text-uppercase w-100 col-6' id='notification-continue-shopping' (click)="onContinueShoppingClick()">
            {{'component.order_notification.continue_shopping' | translate}}
          </button>
          <div *ngIf="updatedOrderDeferTime" class="adjusted-time-message-container" [style.backgroundColor]="((theme$ | async)?.notificationMessageBgColor| rgba: '1')" [style.color]="((theme$ | async)?.notificationMessageTextColor| rgba: '1')">
            <fa-icon [size]="'lg'" [fixedWidth]="true" [icon]="faExclamationCircle"></fa-icon>
            <span class="adjusted-time-message"> {{'component.order_notification.adjusted_time_message' | translate: {orderType: this.order?.orderType.toLocaleLowerCase() , time:updatedOrderDeferTime, date: deferTimeWeekdayName } }} </span>
          </div>
        <button class='btn btn-link btn-undecorated dismiss-btn font-secondary text-uppercase' id='order-notification-close-btn' (click)='onDismissNotificationClick()'>
          <img class="normal-icon" src="assets/img/close.svg" [alt]="'component.order_notification.close_icon' | translate"> {{'component.order_notification.close' | translate}}
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="(viewportService?.viewport$ | async)?.isMobile">
      <div class='padding-wrapper' [ngClass]="{'no-bottom-padding': !(viewportService?.viewport$ | async)?.isMobile}">
        <div class='item-notification-wrapper'>
          <div>
            <fts-order-notification-item-info [item]="notificationItem" [special]="notificationSpecial?.special"></fts-order-notification-item-info>

            <div class="modify-option-wrapper">
              <fts-order-notification-info-message class="item-info-message" [message]="infoMessage"></fts-order-notification-info-message>

              <a [routerLink]="['/editor', 'item', notificationItem.itemId]"
                (click)="modifyItem()"
                [routerLinkActive]="['selection-text-color', 'fw-600', 'disabled']"
                #rla="routerLinkActive"
                *ngIf="notificationItem && !(inOrderDetails$ | async)"
                class="btn btn-link no-padding margin-right-10"
                id='order-notification-modify-btn'>
                {{'component.order_notification.modify_item' | translate}}
              </a>
            </div>
          </div>

          <button class='btn dismiss-button no-padding' id='order-notification-close-btn' (click)='onDismissNotificationClick()' aria-label='Close'>
            <span aria-hidden='true'><fa-icon [icon]="faRemove"></fa-icon></span>
          </button>
        </div>

        <div class="buttons-wrapper">
          <fts-order-notification-upsell-done-message
            *ngIf="showUpsizeDoneMessage || showUpingredientDoneMessage"
            [message]="(showUpsizeDoneMessage ? 'component.order_notification.size_updated' : 'component.order_notification.ingredient_added') | translate">
          </fts-order-notification-upsell-done-message>
          <fts-order-notification-upsell-button
            *ngIf="(notificationItem?.sizeUpsell && !showUpsizeDoneMessage) || (!notificationItem?.sizeUpsell && notificationItem?.ingredientUpsell && !showUpingredientDoneMessage && !hideIngrUpsellAfterSizeUp)"
            [btnLabel]="upsellBtnLabel"
            [loadingSubscription]="notificationItem?.sizeUpsell ? upsellSizeSubscription : upsellIngredientSubscription"
            (click)="upsellBtnClick(notificationItem)">
          </fts-order-notification-upsell-button>
          <div *ngIf="updatedOrderDeferTime" class="adjusted-time-message-container mobile" [style.backgroundColor]="((theme$ | async)?.notificationMessageBgColor| rgba: '1')" [style.color]="((theme$ | async)?.notificationMessageTextColor| rgba: '1')">
            <fa-icon [size]="'lg'" [fixedWidth]="true" [icon]="faExclamationCircle"></fa-icon>
            <span class="adjusted-time-message"> {{'component.order_notification.adjusted_time_message' | translate: {orderType: this.order?.orderType.toLocaleLowerCase() , time:updatedOrderDeferTime, date: deferTimeWeekdayName } }} </span>
          </div>
          <button *ngIf="!(inOrderDetails$ | async)" class='btn action-bg-color action-inverse-text-color primary-btn font-secondary checkout-button btn-wrap-text wrap-text text-uppercase w-100' id='notification-checkout' (click)="onCheckoutNotificationClick()">
            {{'component.order_notification.checkout_button' | translate}}
          </button>
          <button *ngIf="!(inOrderDetails$ | async)" #continueShoppingBtn class='btn primary-bg-color selection-border-color selection-text-color selection-btn font-secondary checkout-button btn-wrap-text wrap-text text-uppercase w-100' id='notification-continue-shopping' (click)="onContinueShoppingClick()">
            {{'component.order_notification.continue_shopping' | translate}}
          </button>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="notificationCoupon && !(inOrderDetails$ | async)">
    <div class="coupon-notification-wrapper">
      <div [ngClass]="{'padded-bottom-10': showCouponInstructionsBtn}">
        <span>{{'component.order_notification.coupon_added_to_order' | translate:{coupon: notificationCoupon?.name} }}<br><hr aria-hidden="true"></span>
        <span *ngIf="!!notificationCoupon.message">{{notificationCoupon.message}}</span>

      </div>
      <div class="d-flex align-items-center" [ngClass]="{'justify-content-between': showCouponInstructionsBtn, 'justify-content-end': !showCouponInstructionsBtn}">
        <button class='btn action-bg-color action-inverse-text-color primary-btn font-secondary text-uppercase'id='coupon-instructions' (click)="handleCouponInstructionsBtnClick()" *ngIf="showCouponInstructionsBtn">
          {{'component.order_notification.coupon_instructions' | translate}}
        </button>
        <button class='btn btn-link btn-undecorated dismiss-btn font-secondary text-uppercase' id='order-notification-close-btn' (click)='onDismissNotificationClick()'>
          <img class="normal-icon" src="assets/img/close.svg" [alt]="'component.order_notification.close_icon' | translate"> {{'component.order_notification.close' | translate}}
        </button>
      </div>
    </div>
  </ng-container>
</div>
